import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ba5690c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "ms-top-bar",
  class: "py-1 px-2 w-100"
}
const _hoisted_2 = { class: "flex gap-2 align-items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-semibold" }, "SAWE-T", -1))
const _hoisted_4 = {
  key: 0,
  class: "flex align-items-center gap-4"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "flex gap-2 align-items-center" }
const _hoisted_7 = {
  key: 0,
  class: "card flex justify-content-center absolute right-0 z-20 border-1"
}
const _hoisted_8 = { class: "flex align-items-center justify-center gap-1 px-2 py-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-semibold" }, "SAWE-T", -1))
const _hoisted_10 = { class: "text-primary font-bold" }
const _hoisted_11 = { class: "flex align-items-center" }
const _hoisted_12 = { class: "ml-2" }
const _hoisted_13 = {
  key: 1,
  class: "ml-auto border-1 surface-border border-round surface-100 text-xs p-1"
}
const _hoisted_14 = { class: "relative overflow-hidden w-full flex align-items-center p-2 pl-3 text-color border-noround" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-user mr-3",
  style: {"font-size":"1.5rem"}
}, null, -1))
const _hoisted_16 = { class: "inline-flex flex-column" }
const _hoisted_17 = { class: "font-bold" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, "Admin", -1))

import { computed, type ComputedRef, onMounted, ref } from 'vue'
import Button from 'primevue/button'
import Toolbar from 'primevue/toolbar'
import Menu from 'primevue/menu'
import Badge from 'primevue/badge'
import { useAuthStore } from '@/store/auth.store'
import { useI18n } from 'vue-i18n'
import SawetLogo from '@/components/SawetLogo/SawetLogo.vue'
import type { MenuItem } from 'primevue/menuitem'
import router from '@/router'


export default /*#__PURE__*/_defineComponent({
  __name: 'LandingHeader',
  setup(__props) {

const authStore = useAuthStore()
let menuOpen = ref<boolean>(false)

const { t } = useI18n()

let user = computed(() => {
  return authStore.user
})

function menuHandler() {
  menuOpen.value = !menuOpen.value
}

const items: ComputedRef<MenuItem[]> = computed(() => [
  {
    separator: true
  },
  {
    label: 'Help',
    icon: 'pi pi-question-circle',
    command: async () => {
      await router.push({
        name: 'HelpView'
      })
    }
  },
  {
    label: t('menu.user.logout'),
    icon: 'pi pi-sign-out',
    size: 'small',
    command: () => {
      authStore.logout()
    }
  },
  {
    separator: true
  }
])

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Toolbar), { class: "bg-transparent border-0" }, {
      start: _withCtx(() => [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(SawetLogo, {
                width: 40,
                height: 40
              }),
              _hoisted_3
            ])
          ]),
          _: 1
        })
      ]),
      end: _withCtx(() => [
        (_unref(user))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_router_link, { to: "/dashboard/wellbeing" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Button), {
                    label: "Dashboard",
                    class: "px-2 py-1.5",
                    text: ""
                  })
                ]),
                _: 1
              }),
              _createElementVNode("i", {
                class: "pi pi-align-right cursor-pointer",
                style: {"font-size":"1.5rem"},
                onClick: menuHandler
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_router_link, { to: "/auth" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Button), {
                      label: "Log in",
                      severity: "secondary",
                      text: ""
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_router_link, { to: "/demonstration" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Button), {
                      id: "demo",
                      label: "Book a demo"
                    })
                  ]),
                  _: 1
                })
              ])
            ]))
      ]),
      _: 1
    }),
    (_unref(menuOpen))
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_unref(Menu), {
            model: items.value,
            class: "w-full md:w-15rem"
          }, {
            start: _withCtx(() => [
              _createElementVNode("span", _hoisted_8, [
                _createVNode(SawetLogo),
                _hoisted_9
              ])
            ]),
            submenuheader: _withCtx(({ item }) => [
              _createElementVNode("span", _hoisted_10, _toDisplayString(item.label), 1)
            ]),
            item: _withCtx(({ item }) => [
              _createElementVNode("a", _hoisted_11, [
                _createElementVNode("span", {
                  class: _normalizeClass(item.icon)
                }, null, 2),
                _createElementVNode("span", _hoisted_12, _toDisplayString(item.label), 1),
                (item.badge)
                  ? (_openBlock(), _createBlock(_unref(Badge), {
                      key: 0,
                      class: "ml-auto",
                      value: item.badge
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true),
                (item.shortcut)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(item.shortcut), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            end: _withCtx(() => [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("span", _hoisted_16, [
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(user) != null ? _unref(user).username : ''), 1),
                  _hoisted_18
                ])
              ])
            ]),
            _: 1
          }, 8, ["model"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})